export default __webpack_public_path__ + "static/media/3130.2db7dbda.jpg";